import { render, staticRenderFns } from "./InputLabel.vue?vue&type=template&id=b9cc162c"
import script from "./InputLabel.vue?vue&type=script&lang=js"
export * from "./InputLabel.vue?vue&type=script&lang=js"
import style0 from "./InputLabel.vue?vue&type=style&index=0&id=b9cc162c&prod&lang=scss"
import style1 from "./InputLabel.vue?vue&type=style&index=1&id=b9cc162c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports